<template>
  <div class="page">
    <van-nav-bar title="结束实习" left-arrow @click-left="$router.go(-1)" z-index="99999" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-form @submit="onSubmit">
      <van-field class="uploader" name="uploader" label="上传附件" :rules="[{ required: false, message: '请上传附件' }]">
        <template #input style="margin-top: 10px">
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
        </template>
      </van-field>
      <div class="button-box">
        <van-button round type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>

    <!-- 选择审批人 -->
    <!-- <reviewer-dialog :code="670" @change="reviewerChange" ref="dialog" @done="saveData()"></reviewer-dialog> -->
  </div>
</template>

<script>
import iApi from '@/utils/internship'
// import ReviewerDialog from './components/reviewerDialog.vue'
import { mapGetters } from 'vuex'
export default {
  // components:{
  //   ReviewerDialog
  // },
  data() {
    return {
      isEdit: false,
      fileList: [],
      form: {
        sxjhid: '',
        userid: ''
      },
      userList: [],
      showPicker: false,
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid'
    }),
  },
  methods: {
    reviewerChange(e) {
      this.form.userid = e
    },

    async upload(e) {
      console.log(e)
      this.form.file = e.file
    },

    // 提交申请
    async onSubmit() {
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postDoneData(this.form)
      if(res.code == '1'){
        this.$toast('提交申请成功')
        setTimeout(()=>{
          this.$router.replace('/internship/applyStatus?config=8')
        }, 800)
      }
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  margin-top: -50px;
  background: #f2f2f2;
}

.button-box {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
}
.van-button {
  
  width: 315px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 25px !important;
}
.img-icon {
  height: 20px;
}
.achieve-box {
  position: relative;
  img {
    width: 335px;
    height: 580px;
    // box-shadow: 5px 5px 1px 0 rgba(74,46,23,0.15);
    margin: 50px auto 0;
    display: block;
    position: relative;
    z-index: 999;
  }
  .text-box {
    width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%);
   
    .info {
      margin-top: 215px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      text-align: center;
      .time {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
    }
    .user-info {
      width: 265px;
      min-height: 62px;
      background: #f2f2f4;
      border-radius: 6px;
      margin: 49px auto 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      padding: 0 15px;
    }
    .work-info {
      margin: 12px auto 0;
      .item {
        margin: 0 auto;
        width: 265px;
        height: 50px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        .title {
          min-width: 92px;
        }
        .content {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          text-align: right;
        }
      }
    }
  }
}
.uploader {
  flex-direction: column;
  /ddep/.van-cell__title {
    margin-bottom: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/done.vue